import React from "react";
import Wavelet from "../../components/Wavelet/Main";
import {useNavigate, useSearchParams} from "react-router-dom"
import Select from "react-select";
import styles from "../../styles/App.module.css";

export function App() {

    const [searchParams, setSearchParams] = useSearchParams();
    const series = searchParams.get("series") as string;

    const options = [
        {value: 'CPI', label: 'CPI'},
        {value: 'GDP', label: 'GDP'},
        {value: 'Money-Supply', label: 'Money-Supply'},
    ];


    const [state, setState] =  React.useState(() => {
        if (series) {
            return series
        } else {
            return 'CPI'
        }
    });

    const navigate = useNavigate();

    const onChange = (value : any) => {
        setState(value.value)
        navigate({
            pathname: '/correlations',
            search: '?series=' + value.value,
        });
    }

    return <>
        <div className="controls">
            <Select className={styles.select}
                    options={options}
                    onChange={onChange}
                    defaultValue={[{value: state.valueOf(), label: state.valueOf()}]}/>
        </div>
        <div className={styles.clear}></div>
        <Wavelet series={state}/>
    </>
}
export default App;
